import { type EnumType } from './EnumType';
import { type AttachmentDto } from './AttachmentDto';
import { initialInterfaceAppearance } from './InterfaceAppearanceDto';
import { LoginLayoutType } from './LoginLayoutType';
import { LoginThemeType } from './LoginThemeType';
import { LoginBackgroundType } from './LoginBackgroundType';
import { OnSaveType } from './OnSaveType';
import { OnAccessType } from './OnAccessType';

export type UiConfigDto = {
  login_layout?: EnumType<LoginLayoutType>;
  login_theme?: EnumType<LoginThemeType>;
  login_logo?: AttachmentDto | null;
  login_primary_color?: string | null;
  login_background_color?: string | null;
  login_panel_color?: string | null;
  login_background_type?: EnumType<LoginBackgroundType>;
  login_background_media?: AttachmentDto | null;
  login_background_overlay_percent?: number;
  login_title?: string | null;
  login_message?: string | null;
  login_support_label?: string | null;
  login_support_url?: string | null;
  login_footer?: string | null;
  id?: string;
  on_save?: EnumType;
  on_type?: EnumType;
  list_record_count?: number;
  modification_date?: string;
  system_name?: string;
  primary_color?: string;
  sidebar_color?: string;
  background_color?: string;
  logo?: AttachmentDto | null;
  splash_type?: EnumType;
  splash_media?: AttachmentDto | null;
  splash_background_color?: string;
  splash_dark_background_color?: string;
};

export const initialUiConfigDto: UiConfigDto = {
  ...initialInterfaceAppearance,
  login_layout: { value: LoginLayoutType.SPLIT, description: 'Dividido' },
  login_theme: { value: LoginThemeType.LIGHT, description: 'Claro' },
  login_logo: null,
  login_primary_color: null,
  login_background_color: null,
  login_panel_color: null,
  login_background_type: { value: LoginBackgroundType.AUTO, description: 'Conforme o layout' },
  login_background_media: null,
  login_background_overlay_percent: 35,
  login_title: null,
  login_message: null,
  login_support_label: null,
  login_support_url: null,
  login_footer: null,
  on_save: { value: OnSaveType.VIEW_SAVED, description: 'Visualizar cadastro' },
  on_type: { value: OnAccessType.VIEW_MODE, description: 'Acessar no modo de visualização' },
  list_record_count: 20,
};

export const updateInitialUiConfigDto = (uiConfig?: UiConfigDto): UiConfigDto => ({
  ...initialUiConfigDto,
  ...uiConfig,
  login_layout: uiConfig?.login_layout ?? initialUiConfigDto.login_layout,
  login_theme: uiConfig?.login_theme ?? initialUiConfigDto.login_theme,
  login_background_type: uiConfig?.login_background_type ?? initialUiConfigDto.login_background_type,
  login_background_overlay_percent: uiConfig?.login_background_overlay_percent ?? 35,
  system_name: uiConfig?.system_name ?? initialInterfaceAppearance.system_name,
  primary_color: uiConfig?.primary_color ?? initialInterfaceAppearance.primary_color,
  sidebar_color: uiConfig?.sidebar_color ?? initialInterfaceAppearance.sidebar_color,
  background_color: uiConfig?.background_color ?? initialInterfaceAppearance.background_color,
  logo: uiConfig?.logo ?? null,
  splash_type: uiConfig?.splash_type ?? initialInterfaceAppearance.splash_type,
  splash_media: uiConfig?.splash_media ?? null,
  splash_background_color: uiConfig?.splash_background_color ?? initialInterfaceAppearance.splash_background_color,
  splash_dark_background_color:
    uiConfig?.splash_dark_background_color ?? initialInterfaceAppearance.splash_dark_background_color,
});
